import { render, staticRenderFns } from "./ProductListPriceDisplay.vue?vue&type=template&id=31c1a6de&scoped=true"
import script from "./ProductListPriceDisplay.vue?vue&type=script&lang=ts"
export * from "./ProductListPriceDisplay.vue?vue&type=script&lang=ts"
import style0 from "./ProductListPriceDisplay.vue?vue&type=style&index=0&id=31c1a6de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c1a6de",
  null
  
)

export default component.exports